(function () {
  function openDrawer(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    dialog.showModal();
    window.requestAnimationFrame(function () {
      dialog.classList.add('is-open');
    });
  }

  function closeDrawer(dialog) {
    if (!dialog) return;
    dialog.classList.remove('is-open');
    window.setTimeout(function () {
      if (dialog.open) dialog.close();
    }, 300);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
      return;
    }

    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      closeDrawer(closer.closest('dialog'));
      return;
    }

    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('skindiary-benefits__drawer')) {
      var rect = event.target.getBoundingClientRect();
      var insideDialog =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (!insideDialog) closeDrawer(event.target);
    }
  });

  document.addEventListener(
    'close',
    function (event) {
      if (event.target.classList && event.target.classList.contains('skindiary-benefits__drawer')) {
        event.target.classList.remove('is-open');
      }
    },
    true
  );
})();
